import { UseAuth } from "./AuthContext/AuthContext"
import { Usedata } from "./Context/Allcontext"

function MobileNav({nav}){
    const {ActivLogin} = Usedata()
    const {Logout , crentuser}  = UseAuth()
    //const email = crentuser && crentuser.email


    const LogoutHandale = async () => {
        try{
            await Logout()
        } catch (error) {
            console.log(error)
        }
    }
    return(
    <div className={nav ? "nav_mobile active" : "nav_mobile"}>
        <div className="haye">
            <ul className="links_mobile">
                <li>
                    <a href="#">
                        <i className="fa-solid fa-house"></i> Home
                    </a>
                </li>
                <li>
                    <a href="#">
                        <i className="fa-solid fa-magnifying-glass-dollar"></i> Qiimaha Maanta
                    </a>
                </li>
                <li>
                    <a href="#">
                        <i className="fa-solid fa-list-check"></i> Dhaqdhaqaaq
                    </a>
                </li>

                {/* {crentuser && crentuser ?
                <li>
                <a href="#">
                    <i className="fa-solid fa-list-check"></i>
                    
                    Soo Dhawaaw {email}
                </a>
                </li>
                :
                <>
                </>
                } */}
            </ul>
            {crentuser && crentuser ? 
            <button onClick={LogoutHandale} className="nav_mb_btn"><i className="fa-solid fa-arrow-right-to-bracket"></i> Xidho</button>
            :<button onClick={ActivLogin} className="nav_mb_btn"><i className="fa-solid fa-arrow-right-to-bracket"></i> Gal</button>
            }
            
        </div>
    </div>
    )
}


export default MobileNav